<template>
  <div class="lp-component-base">
    <div class="head-area">
      <img class="head-img" src="/static/img/deluxe/1/lp_head_image2.png" alt="">
      <div class="inner">
        <h1>（一部無料）{{ itemName }}</h1>
        <span class="item-price">
          {{ itemPrice | addDigit }}円（税込）<br>※月額会員の方は追加料金不要
        </span>
      </div>
    </div>
    <div class="desc-body">
      <div class="btn-area">
        <span class="button-link" @click="onFreeClick"><span class="button-face" v-html="freeButtonFace"></span></span>
        <template v-if="isSubscActive">
          <p class="notice">＜一部無料＞文字数2000字以上！暮れの酉、法演、斗弥、叶ここが占う恋の現状・お相手の気持ち・恋の未来。4人がかりであなたの恋を応援します！</p>
        </template>
        <template v-else>
          <span class="button-link--fill" @click="onSubscClick"><span class="button-face" v-html="`月額${subscPrice}円だけで占う`"></span></span>
          <p class="notice">テレビ東京「占いリアリティ―ショー どこまで言っていいですか」に出演中の暮れの酉・法演・斗弥・叶ここが、テレビ放送そのままに、よってたかってあなたの恋を応援！気になるお相手の恋愛観、あなたへの気持ち、恋の未来＋αを2000字以上のボリュームでお届けします。</p>
        </template>
      </div>
      <div class="menus-list">
        <div class="inner">
          <h2>メニュー</h2>
          <div class="menu-item" v-for="(item, idx) in menusList" :key="idx">
            <span class="counselor">{{ item.counselor_name }}</span>
            <span class="title">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <p class="notice" v-if="!isSubscActive">占うお相手の生年月日情報をご準備ください。<br>また、占いの購入には<span class="link" @click="onLoginLinkClick">ログイン（登録無料）</span>が必要です。<br><strong>会員の方はログイン後、会員用ホームからこの占いをお楽しみいただけます。</strong></p>
      <div class="btn-area" v-if="!isSubscActive">
        <span class="button-link" @click="onBuyButtonClick"><span class="button-face" v-html="buyButtonFace"></span></span>
      </div>
      <div class="tellers">
        <div class="tellers__title">占い師紹介</div>
        <div class="tellers__list">
          <div v-for="(teller, i) in tellerLists" :key="i" class="tellers__box">
            <div class="tellers__inn">
              <img :src="teller.tellerList.thumbnail" :alt="teller.name" class="tellers__thumb">
              <div class="tellers__infos">
                <div class="tellers__name">{{ teller.name }}<span v-if="teller.kana">（{{ teller.kana }}）</span></div>
                <div class="tellers__description">{{ teller.tellerList.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <floating-banner-base class="banner-base" :show-floating-banner="showFloatingBanner">
      <floating-banner-subsc
        :item-price="itemPrice"
        :subsc-price="subscPrice"
        :subsc-url="subscUrl"
        :buy-link="buyLink"
      />
    </floating-banner-base>

  </div>
</template>

<script>
import { BASIC_DATA_BY_LPID } from '@/utvStore/components/recommend/lp/commons'
import FloatingBannerBase from '@/utvStore/components/recommend/lp/partials/FloatingBannerBase'
import FloatingBannerSubsc from '@/utvStore/components/recommend/lp/partials/FloatingBannerSubsc'

export default {
  name: 'DeluxeLpA',
  components: {
    FloatingBannerBase,
    FloatingBannerSubsc,
  },
  filters: {
    // 金額の桁を追加　ex) 1000 -> 1,000
    addDigit (value) {
      return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  },
  props: {
    itemName: {
      type: String,
      default: null,
    },
    itemPrice: {
      type: Number,
      default: null,
    },
    subscPrice: {
      type: Number,
      default: null,
    },
    isSubscActive: {
      type: Boolean,
      default: false,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    freeLink: String,
    buyLink: String,
    subscUrl: String,
  },
  computed: {
    freeButtonFace(){
      if(this.isSubscActive){
        return `占う`
      }else {
        return `<span class="face-body">一部無料で占う</span><span class="notice">※ログイン不要</span>`
      }
    },
    buyButtonFace(){
      return `購入する`
    },
    // itemPriceStr(){
    //   if(this.isSubscActive){
    //      return `<span class="strike-through">￥${String(this.itemPrice).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span><span class="add-note">追加料金なし</span>`
    //   }else {
    //     return `￥${String(this.itemPrice).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}（税込）`
    //   }
    // },
    // 表示順を元にデータ参照
    tellerLists() {
      let arr = []
      for (let id of this.tellerListsOrder) {
        arr.push(BASIC_DATA_BY_LPID[id].information.profile)
      }
      return arr
    },
  },
  data(){
    return {
      showFloatingBanner: false,
      // 表示順
      tellerListsOrder: [3, 1, 2, 4],
    }
  },
  mounted(){
    console.log('<received data>:\n- itemName:[%s]\n- itemPrice:[%s]\n- menusList%O', this.itemName, this.itemPrice, this.menusList)
    // this.onScroll()
    // window.addEventListener('scroll', this.onScroll)

  },
  methods: {
    onScroll(){
      const topOffset = 50
      const bottomOffset = 100
      const sc = window.pageYOffset
      const ih = window.innerHeight
      // this.showFloatingBanner = !this.isSubscActive && sc > topOffset && sc < this.$el.clientHeight - ih - bottomOffset
    },
    onFreeClick(){
      window.gtag('event', 'click', {
        'event_category': this.isSubscActive ? 'Deluxe-subsc-paid-content-button' : 'Deluxe-free-shindan',
        'event_label': '10001'
      })
      location.href = this.$handoverParams(this.isSubscActive ? this.buyLink : this.freeLink)
    },
    onSubscClick(){
      window.gtag('event', 'click', {
        'event_category': 'Deluxe-menu-subsc-button',
        'event_label': '10001'
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    onBuyButtonClick(){
      window.gtag('event', 'click', {
        'event_category': 'Deluxe-paid-content-button',
        'event_label': '10001'
      })
      location.href = this.$handoverParams(this.buyLink)
    },
    onLoginLinkClick(){
      location.href = this.$handoverParams(this.buyLink)
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.lp-component-base {
  color: $col_temp_gray6;
  .head-area{
    .head-img {
      display: block;
      width: 100%;
    }
    .inner {
      padding: 16px 20px 24px;
      h1 {
        color: $col_base_black;
        font-size: 18px;
        font-weight: bold;
        line-height: 23px;
        margin: 0 0 10px;
      }
      .item-price {
        font-size: 18px;
        font-weight: 600;
        color: $col_temp_key1;
        display: block;
        /deep/ {
          .strike-through {
            text-decoration: line-through;
          }
          .add-note {
            font-size: 0.75em;
            display: inline-block;
            margin-left: 4px;
          }
        }
      }
    }
  }
  .desc-body {
    padding: 0 20px 60px;
    .menus-list {
      padding: 1px;
      border-radius: 10px;
      background: linear-gradient(86.53deg, $col_temp_key1 21.4%, $col_temp_key2 76.64%);
      overflow: hidden;
      .inner {
        padding: 25px 20px 40px;
        background: white;
        border-radius: 9px;
        h2 {
          margin: 0 0 20px;
        }
        .menu-item {
          width: 100%;
          padding: 0 0 0 64px;
          position: relative;
          margin-bottom: 12px;
          &:last-child{
            margin-bottom: 0;
          }
          .counselor {
            position: absolute;
            top: 2px;
            left: 0;
            background: $col_temp_key1;
            width: 56px;
            height: 20px;
            line-height: 1;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 30px;
            color: white;
          }
        }
      }

    }
    .tellers {
      margin: 60px auto 0;
      &__title {
        color: $col_base_black;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        text-align: center;
        margin: 0 0 24px;
      }
      &__box {
        margin: 0 auto 16px;
        padding: 1px;
        border-radius: 10px;
        background-image: linear-gradient(90deg, #FF7497, #CB8BFF);
        &:last-child {
          margin-bottom: 0;
        }
      }
      &__inn {
        background: #FFFFFF;
        border-radius: 10px;
        padding: 20px;
        display: flex;
        align-items: flex-start;
      }
      &__thumb {
        flex: 0 1 auto;
        width: 28%;
        max-width: 80px;
      }
      &__infos {
        flex: 1 1 auto;
        margin: 0 0 0 16px;
        font-size: 14px;
        line-height: 16px;
        text-align: justify;
        color: $col_base_black;
      }
      &__name {
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        margin: 0 0 12px;
      }
      &__description {
        font-weight: 300;
        line-height: 20px;
        margin: 0;
      }
    }
  }
}
.notice {
  font-size: 13px;
  .link {
    color: $col_temp_key1;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
}

.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }
  &.disable {
    pointer-events: none;
    background: #dcdfe2;
    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}
.button-link--fill {
  @extend .button-link;
  margin: 16px auto 24px;
  &::before {
    display: none;
  }
  .button-face {
    color: #fff;
    background: none;
    -webkit-text-fill-color: initial;
    -webkit-background-clip: border-box;
  }
}

/deep/ .floating-banner {
  height: 120px;
  overflow: hidden;
  bottom: 50px!important;
  @include mq('w580'){
    bottom: 0!important;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/deluxe/components/DeluxeLpA.vue